import ConditionalRender from "components/ConditionalRender";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const NavAssetArrows = ({ navInfo, onNavigate }) => {
    return (
        <div className="d-flex gap-2">
            <ConditionalRender condition={navInfo.back}>
                <button
                    className="btn btn-outline-secondary px-3 py-1"
                    title={navInfo.back}
                    onClick={() => onNavigate(navInfo.back)}>
                    <FontAwesomeIcon icon="chevron-left" />
                </button>
            </ConditionalRender>
            <ConditionalRender condition={navInfo.next}>
                <button
                    className="btn btn-outline-secondary px-3 py-1"
                    title={navInfo.next}
                    onClick={() => onNavigate(navInfo.next)}>
                    <FontAwesomeIcon icon="chevron-right" />
                </button>
            </ConditionalRender>
        </div>
    );
};
export default NavAssetArrows;